import { render, staticRenderFns } from "./StartupUser.vue?vue&type=template&id=423cc7fa"
import script from "./StartupUser.vue?vue&type=script&lang=js"
export * from "./StartupUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports